import React from "react";
import { Link } from "react-router-dom";

export default function Admin() {
  return (
    <div>
      <Link to="products">Products</Link>
    </div>
  );
}
